import http from './httpService';
import jwtDecode from 'jwt-decode';
// Importing this also runs the legacy key migration, which has to happen before the getJwt() below
// reads the token — see the migration note in storage.js
import { readItem, removeItem, storageKeys, writeItem } from '../utils/storage';
import { clearSongCache } from '../utils/songCache';

const apiEndPoint = '/auth';
const tokenKey = storageKeys.token;

http.setJwt(getJwt());

export async function signin(email, password) {
  const { data: jwt } = await http.post(apiEndPoint, { email, password });
  writeItem(tokenKey, jwt);
  http.setJwt(jwt);
}

export function signout() {
  removeItem(tokenKey);
  // Cached songs can hold an admin's hidden parts, so they don't outlast the account
  clearSongCache();
  http.setJwt(null);
}

export function signinWithJwt(jwt) {
  writeItem(tokenKey, jwt);
  http.setJwt(jwt);
}

export function getCurrentUser() {
  try {
    const jwt = readItem(tokenKey);
    return jwtDecode(jwt);
  } catch (ex) {
    return null;
  }
}

export function getJwt() {
  return readItem(tokenKey);
}

const authService = {
  signin,
  signinWithJwt,
  signout,
  getCurrentUser,
  getJwt,
};

export default authService;
